import { keyToYm, toMonthKey } from "../lib/finance";
import { DEFAULT_ALLOCATION, DEFAULT_RETURNS, DEFAULT_TAX } from "../lib/invest";

export const STORAGE = {
  loans: "lrp.v2.loans",
  settings: "lrp.v2.settings",
  recovery: "lrp.v2.recovery",
  compare: "lrp.v2.compare",
  migrated: "lrp.v2.migrated",
  // Written by the original app. Read for migration, never deleted.
  legacyLoan: "loanDetails",
  legacyPercentages: "percentages",
  user: "LoanTokenUser",
  displayName: "displayName",
};

export const LOAN_TYPES = [
  { id: "home", label: "Home loan" },
  { id: "car", label: "Car loan" },
  { id: "personal", label: "Personal loan" },
  { id: "education", label: "Education loan" },
  { id: "business", label: "Business loan" },
  { id: "gold", label: "Gold loan" },
  { id: "credit", label: "Credit card EMI" },
  { id: "other", label: "Other" },
];

export const LOAN_TYPE_LABEL = Object.fromEntries(LOAN_TYPES.map((t) => [t.id, t.label]));

export const DEFAULT_SETTINGS = {
  theme: "system",
  sidebarCollapsed: false,
  inflationRate: 6,
  returns: { ...DEFAULT_RETURNS },
  tax: { ...DEFAULT_TAX },
  monthlyIncome: 0,
  showDemo: true,
};

export const DEFAULT_RECOVERY = {
  mode: "interest", // "interest" | "goal"
  source: "custom", // "custom" | "portfolio" | <loanId>
  custom: { principal: 2000000, tenureYears: 15, rate: 8.5 },
  goal: { amount: 2500000, years: 10 },
  allocation: { ...DEFAULT_ALLOCATION },
  returns: null, // null → use Settings returns
  inflationProof: false,
};

export const DEFAULT_COMPARE = {
  loanId: null,
  surplus: null, // null → suggested from EMI
  lumpSum: 0,
  customRate: 10,
  tax: "gains",
  real: false,
};

/** Illustrative loans shown only while the user has none of their own. */
export function demoLoans(nowKey = toMonthKey()) {
  return [
    {
      id: "demo-home",
      demo: true,
      name: "Home loan",
      type: "home",
      lender: "",
      principal: 4500000,
      annualRate: 8.5,
      tenureMonths: 240,
      startYm: keyToYm(nowKey - 38),
      colorIndex: 0,
      strategy: null,
    },
    {
      id: "demo-car",
      demo: true,
      name: "Car loan",
      type: "car",
      lender: "",
      principal: 800000,
      annualRate: 9.2,
      tenureMonths: 60,
      startYm: keyToYm(nowKey - 22),
      colorIndex: 1,
      strategy: null,
    },
    {
      id: "demo-personal",
      demo: true,
      name: "Personal loan",
      type: "personal",
      lender: "",
      principal: 300000,
      annualRate: 13,
      tenureMonths: 36,
      startYm: keyToYm(nowKey - 27),
      colorIndex: 2,
      strategy: null,
    },
  ];
}
